/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Colony not found
 * @export
 * @interface GetCharactersCharacterIdPlanetsPlanetIdNotFound
 */
export interface GetCharactersCharacterIdPlanetsPlanetIdNotFound {
    /**
     * error message
     * @type {string}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdPlanetsPlanetIdNotFound interface.
 */
export function instanceOfGetCharactersCharacterIdPlanetsPlanetIdNotFound(value: object): value is GetCharactersCharacterIdPlanetsPlanetIdNotFound {
    return true;
}

export function GetCharactersCharacterIdPlanetsPlanetIdNotFoundFromJSON(json: any): GetCharactersCharacterIdPlanetsPlanetIdNotFound {
    return GetCharactersCharacterIdPlanetsPlanetIdNotFoundFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdPlanetsPlanetIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdPlanetsPlanetIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetCharactersCharacterIdPlanetsPlanetIdNotFoundToJSON(json: any): GetCharactersCharacterIdPlanetsPlanetIdNotFound {
    return GetCharactersCharacterIdPlanetsPlanetIdNotFoundToJSONTyped(json, false);
}

export function GetCharactersCharacterIdPlanetsPlanetIdNotFoundToJSONTyped(value?: GetCharactersCharacterIdPlanetsPlanetIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

